/**
 * @Author: zachalam
 * @Date:   2017-01-19T13:38:09-08:00
 * @Last modified by:   zachalam
 * @Last modified time: 2017-01-19T16:13:02-08:00
 */

import { CLEAR_EVERYTHING } from './types/Index.d';
import common from './common';
import auth from './auth';
import profile from './profile';
import extprofile from './extprofile';
import fav from './fav';
import settings from './settings';
import convo from './convo';
import blocked from './blocked';
import biometrics from './biometrics';
import billing from './billing';
import search from './search';
import meta from './meta';
import offers from './offers';
import credits from './credits';
import counter from './counter';
import dashboard from './dashboard';
import notification from './notification';
import global_notification from './globalnotification';
import unlink from './unlink';
import alerts from './alerts';
import mail from './mail';
import ddc from './ddc';
import uploadSnackbar from './uploadSnackbar';
import unreadOneTapOffersCount from './unreadOffersCount';
import notificationBanners from './notificationBanners';
import attributes from './attributes';
import { combineReducers } from 'redux';

const appReducer = combineReducers({
  common: common,
  auth: auth,
  profile: profile,
  extprofile: extprofile,
  fav: fav,
  settings: settings,
  convo: convo,
  blocked: blocked,
  billing: billing,
  search: search,
  meta: meta,
  offers: offers,
  credits: credits,
  notification: notification,
  counter: counter,
  dashboard: dashboard,
  unlink: unlink,
  alerts: alerts,
  global_notification: global_notification,
  biometrics: biometrics,
  mail: mail,
  ddc: ddc,
  uploadSnackbar: uploadSnackbar,
  unreadOneTapOffersCount: unreadOneTapOffersCount,
  notificationBanners: notificationBanners,
  attributes: attributes,
});

const rootReducer = (state: any, action: any): any => {
  if (action.type === CLEAR_EVERYTHING) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
